import React from 'react';
import NavBar from '../../components/navbar/navBarComponent';
import Breadcrumb from '../../components/breadcrumb/breadcrumbComponent';
import MenuItem from '../../components/menu/menuItem';

const OpenAccountPage = (props) => {

  const breadcrumbItems = [
    { name: 'Menu', link: '/menu' },
    { name: 'Apertura de Cuenta', link: '/open-account' },
  ];

  return (
    <div id="main-open-account" className="container-fluid page">
      <NavBar cart={props.cart} isLogIn={props.isLogIn} />
      <Breadcrumb page='open-account' items={breadcrumbItems} />
      <div className="menu-container">
        <MenuItem
          key="open_account_form"
          title="Formulario Apertura Cuenta"
          text="Completar formulario de apertura"
          icon="point_of_sale"
          link="https://forms.gle/Ks1ZTG1RFDx19g328"
          external={true}
        />
        <MenuItem
          key="legajo_impositivo"
          title="Legajo Impositivo"
          text="Descargar legajo impositivo"
          icon="file_download"
          link="https://drive.google.com/file/d/1B7LlbkbX7Lyg_9gTPszUnDK055R_FTI0/view?usp=sharing"
          external={true}
        />
      </div>
    </div>);
};

export default OpenAccountPage;